import { __extends } from "tslib";
import { MethodBase, _Shader_MethodBase } from './MethodBase';
/**
 * EffectAlphaMaskMethod allows the use of an additional texture to specify the alpha value of the material. When used
 * with the secondary uv set, it allows for a tiled main texture with independently varying alpha (useful for water
 * etc).
 */
var EffectAlphaMaskMethod = /** @class */ (function (_super) {
    __extends(EffectAlphaMaskMethod, _super);
    /**
     * Creates a new EffectAlphaMaskMethod object.
     *
     * @param texture The texture to use as the alpha mask.
     * @param useSecondaryUV Indicated whether or not the secondary uv set for the mask. This allows mapping alpha independently.
     */
    function EffectAlphaMaskMethod(texture, useSecondaryUV) {
        if (useSecondaryUV === void 0) { useSecondaryUV = false; }
        var _this = _super.call(this) || this;
        _this._texture = texture;
        _this._useSecondaryUV = useSecondaryUV;
        if (_this._texture)
            _this.iAddTexture(_this._texture);
        return _this;
    }
    Object.defineProperty(EffectAlphaMaskMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectAlphaMaskMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectAlphaMaskMethod.prototype, "texture", {
        /**
         * The texture to use as the alpha mask.
         */
        get: function () {
            return this._texture;
        },
        set: function (value) {
            if (this._texture == value)
                return;
            if (this._texture)
                this.iRemoveTexture(this._texture);
            this._texture = value;
            if (this._texture)
                this.iAddTexture(this._texture);
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectAlphaMaskMethod.prototype, "useSecondaryUV", {
        /**
         * Indicated whether or not the secondary uv set for the mask. This allows mapping alpha independently, for
         * instance to tile the main texture and normal map while providing untiled alpha, for example to define the
         * transparency over a tiled water surface.
         */
        get: function () {
            return this._useSecondaryUV;
        },
        set: function (value) {
            if (this._useSecondaryUV == value)
                return;
            this._useSecondaryUV = value;
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    EffectAlphaMaskMethod.assetType = '[asset EffectAlphaMaskMethod]';
    return EffectAlphaMaskMethod;
}(MethodBase));
export { EffectAlphaMaskMethod };
import { ShaderBase } from '@awayjs/renderer';
import { ImageTexture2D } from '../textures/ImageTexture2D';
/**
 * _Shader_EffectAlphaMaskMethod allows the use of an additional texture to specify the alpha value of the material. When used
 * with the secondary uv set, it allows for a tiled main texture with independently varying alpha (useful for water
 * etc).
 */
var _Shader_EffectAlphaMaskMethod = /** @class */ (function (_super) {
    __extends(_Shader_EffectAlphaMaskMethod, _super);
    /**
     * Creates a new _Shader_EffectAlphaMaskMethod object.
     */
    function _Shader_EffectAlphaMaskMethod(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     * @inheritDoc
     */
    _Shader_EffectAlphaMaskMethod.prototype._initVO = function (chunkVO) {
        var texture = this._method.texture || new ImageTexture2D();
        this._alphaMask = texture.getAbstraction(this._shader);
        this._alphaMask._initVO(chunkVO);
        if (this._method.useSecondaryUV)
            this._shader.secondaryUVDependencies++;
        else
            this._shader.uvDependencies++;
    };
    /**
     * @inheritDoc
     */
    _Shader_EffectAlphaMaskMethod.prototype._initConstants = function () {
        this._alphaMask._initConstants();
    };
    /**
     * @inheritDoc
     */
    _Shader_EffectAlphaMaskMethod.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var temp = registerCache.getFreeFragmentVectorTemp();
        return this._alphaMask._getFragmentCode(temp, registerCache, sharedRegisters, this._method.useSecondaryUV ? sharedRegisters.secondaryUVVarying : sharedRegisters.uvVarying) +
            'mul ' + targetReg + ', ' + targetReg + ', ' + temp + '.x\n';
    };
    /**
     * @inheritDoc
     */
    _Shader_EffectAlphaMaskMethod.prototype._activate = function () {
        _super.prototype._activate.call(this);
        this._alphaMask.activate();
    };
    _Shader_EffectAlphaMaskMethod.prototype._setRenderState = function (renderState) {
        this._alphaMask._setRenderState(renderState);
    };
    return _Shader_EffectAlphaMaskMethod;
}(_Shader_MethodBase));
export { _Shader_EffectAlphaMaskMethod };
ShaderBase.registerAbstraction(_Shader_EffectAlphaMaskMethod, EffectAlphaMaskMethod);
